module.exports = __webpack_public_path__ + "img/btn_zc1_jr2.0cb3eb51.png";